import { getObjectInitialCompletionSuccess } from '../../../../../../redux/reducers/insertion/insertionFeature'
import { getInsertionGeoCoordinatesCompletionSuccess } from '../../../../../../redux/reducers/address/addressFeature'
import { queryGeoCodes } from '../../../../../../redux/thunks/gisService/gisService'
import { getAttachmentsInitialCompletionSuccess } from '../../../../../../redux/reducers/multimedia/multimediaFeature'
import { configureObjectChooser } from '../../../../../../redux/actions/flowInformation/flowInformation'
import { DisplayObjectChooserType } from '../../../../../../@types/object-chooser-types'
import { useCallback } from 'react'
import { useAppDispatch } from '../../../../../../app/hooks'
import { ConvertedRealEstate } from '../../../../../../@types/real-estate-api-types'
import { GeoCoordinates } from '../../../../../../@types/types'
import { validateCurrentInsertion } from '../../../../../../redux/thunks/insertionData/insertionData'

export function useOpenWizardWithCurrentDataCallback(
  object: ConvertedRealEstate,
  createNewRealEstateInOma: boolean = false
) {
  const dispatch = useAppDispatch()

  return useCallback(() => {
    const { listing, meta, geoCoordinates } = object

    dispatch(
      getObjectInitialCompletionSuccess({
        insertionData: { ...listing, published: false },
        insertionIdentification: {
          ...meta,
          realEstateId: createNewRealEstateInOma ? undefined : meta.realEstateId,
        },
      })
    )
    if (hasValidGeoCoordinates(geoCoordinates)) {
      dispatch(getInsertionGeoCoordinatesCompletionSuccess({ geoCoordinates: geoCoordinates! }))
    } else {
      dispatch(queryGeoCodes())
    }
    object.attachments && dispatch(getAttachmentsInitialCompletionSuccess({ initAttachments: object.attachments }))

    dispatch(configureObjectChooser(DisplayObjectChooserType.NO, undefined, true, true))

    dispatch(validateCurrentInsertion())
  }, [createNewRealEstateInOma, dispatch, object])
}

const hasValidGeoCoordinates = (coordinates: GeoCoordinates | undefined) => {
  return !!(coordinates && !(coordinates.latitude == 0 && coordinates.longitude == 0))
}
